import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInsights = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.0277 9.57189V3.59454C10.0277 3.35374 10.215 3.15039 10.4558 3.15039C13.7655 3.15039 16.4492 5.83404 16.4492 9.14379C16.4492 9.3846 16.2459 9.57189 16.005 9.57189H10.0277ZM2.75 10.4281C2.75 7.18256 5.16074 4.49623 8.28854 4.06813C8.5347 4.03335 8.7434 4.23134 8.7434 4.48018V10.8562L12.9308 15.0435C13.11 15.2228 13.0966 15.5171 12.8906 15.6616C11.8418 16.4108 10.5575 16.8496 9.1715 16.8496C5.6263 16.8496 2.75 13.976 2.75 10.4281ZM16.8345 10.8562C17.0833 10.8562 17.2786 11.0649 17.2465 11.311C17.0405 12.8067 16.3208 14.1365 15.2692 15.1185C15.1087 15.2683 14.8572 15.2576 14.702 15.0997L10.4558 10.8562H16.8345Z",
		fill: "#0D2976"
	})
});
export default SvgInsights;
